<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">媒体管理</li>
      </ol>
    </div>
    <div class="content-operator content-border">
      <el-button type="primary" @click="headerBatchRecommend(1)" size="small">批量推荐</el-button>
      <el-button type="primary" @click="headerBatchRecommend(0)" size="small">批量取消</el-button>
      <el-button type="primary" size="small"
                 @click="()=>{this.visible=true}">
        添加
      </el-button>
    </div>
    <div class="content-query content-border">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item label="　关键词：">
          <el-input placeholder="请输入关键词" v-model="query.keyword"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitQuery(1)" size="small">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <hr/>
    <div class="title">
      <span>媒体列表</span>
    </div>
    <el-table highlight-current-row :data="tableData" border ref="multipleTable"
              @selection-change="handleSelectionChange">
      <el-table-column align="center" type="index"/>
      <el-table-column align="center" type="selection"/>
      <el-table-column align="center" label="名称" prop="name"/>
      <el-table-column align="center" label="封面" prop="name">
        <template slot-scope="scope">
          <img :src="scope.row.coverImg" alt="" width="100px" height="100px">
        </template>
      </el-table-column>
      <el-table-column align="center" label="媒体类型">
        <template slot-scope="scope">
          <el-tag effect="dark">
            {{ mediaTypeMap[scope.row.type] }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="视频方向">
        <template slot-scope="scope">
          <el-tag effect="dark">
            {{ directionMap[scope.row.direction] }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="点击量" prop="volume"/>
      <el-table-column align="center" fixed="right" label="操作" width="250px">
        <template slot-scope="scope">
          <el-tooltip content="修改" placement="top"
                      effect="light">
            <el-button type="primary" size="mini" round icon="el-icon-setting"
                       @click="handleSelectId(scope.row)"/>
          </el-tooltip>
          <el-tooltip content="删除" placement="top"
                      effect="light">
            <el-button type="danger" @click="headerDeleteMedia(scope.row.id)" size="mini"
                       icon="el-icon-delete" el-icon-delete round/>
          </el-tooltip>
          <el-tooltip v-if="0===scope.row.recommend"
                      content="推荐" placement="top"
                      effect="light">
            <el-button type="primary" icon="el-icon-star-off"
                       @click="headerRecommend(scope.row,1)" size="mini" round>
              推荐
            </el-button>
          </el-tooltip>
          <el-tooltip v-else-if="1===scope.row.recommend"
                      content="取消推荐" placement="top"
                      effect="light">
            <el-button icon="el-icon-star-off" type="danger" @click="headerRecommend(scope.row,0)"
                       size="mini" round>
              取消推荐
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <vue-pager v-bind:datafile="fillData" url="media/pageMedia" v-bind:query="query" ref="pager"
               v-bind:init="true"></vue-pager>
    <media-detail :visible.sync="visible" :select-id.sync="selectId" title="视频" v-on:getList="submitQuery(1)"/>
  </div>
</template>
<script>
import MediaDetail from "@/views/media/media-detail";

export default {
  data() {
    return {
      visible: false,
      sellers: [],
      tableData: [],
      query: {},
      checkInputs: [],
      multipleSelection: [],
      mediaTypes: [],
      directions: [],
      mediaTypeMap: {},
      directionMap: {},
    }
  },
  components: {MediaDetail},
  created() {
    this.mediaTypes = this.$common.enum_config('EMediaType')
    this.mediaTypes.forEach((item) => {
      this.mediaTypeMap[item.name] = item.label
    })
    this.directions = this.$common.enum_config('EDirection')
    this.directions.forEach((item) => {
      this.directionMap[item.name] = item.label
    })
  },
  methods: {
    handleSelectId(row) {
      this.selectId = row.id
      this.visible = true
    },
    handleSelectionChange(val) {
      this.checkInputs = val;
    },
    fillData(response) {
      this.tableData = response.items || [];
    },
    submitQuery(_num) {
      var _this = this;
      _this.tableData = [];
      _this.$refs.pager.gotoPage(_num);
    },
    findSeller() {
      var _this = this;
      _this.$common.my_ajax({
        url: 'seller/pageSeller',
        data: {
          limit: -1
        },
        success: function (response) {
          _this.sellers = response.items;
        }
      });
    },
    headerRecommend(row, recommend) {
      var _this = this;
      _this.$common.my_ajax({
        url: 'media/setRecommend',
        data: {
          mediaId: row.id,
          recommend: recommend
        },
        success: function (response) {
          _this.$message({
            message: '修改成功',
            type: 'success',
            duration: 1000,
            onClose() {
              _this.$set(row, 'recommend', recommend);
            }
          });
        }
      });
    },
    headerBatchRecommend(recommend) {
      const _this = this;
      const ids = [];
      if (0 === _this.checkInputs.length) {
        _this.$message({
          type: 'error',
          message: '请先选择数据',
          duration: 1000,
        });
        return false;
      }
      for (let i = 0; i < _this.checkInputs.length; i++) {
        let checkInput = _this.checkInputs[i];
        ids.push(checkInput.id);
      }
      _this.$common.my_ajax({
        url: 'media/batchRecommend',
        data: {
          ids,
          recommend
        },
        contentType: 'application/json',
        success: function (response) {
          _this.$message({
            message: '修改成功',
            type: 'success',
            duration: 1000,
            onClose() {
              _this.submitQuery(1);
            }
          });
        }
      });
    },
    headerDeleteMedia(_id) {
      var _this = this;
      _this.$common.my_ajax({
        url: 'media/deleteMedia',
        data: {
          mediaId: _id
        },
        success: function (response) {
          _this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1000,
            onClose: function () {
              _this.submitQuery(_this.query.current);
            }
          });
        }
      });
    }
  },
}
</script>
<style scoped>
</style>
